let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iFE2p")).then(() => parcelRequire('3kT7K'));